import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["qa-button", { light: _ctx.light, pill: _ctx.pill, text: _ctx.text }])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}